import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import GeneralContainer from '../components/GeneralContainer'

export default function N25_10_13() {
  return (
    <NoteContainer date={'13/10/2025'} version="20.11.0">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção da apresentação de uma idade</TaskTitle>
                <TaskBreadcrumb>Geral / Idades de pessoas</TaskBreadcrumb>
                <TaskDescription>
                  Corrigido o erro que mostrava a idade de uma pessoa como indefinida caso o número de meses fosse zero
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>

        <ModuleContainer moduleName="SCHEDULES">
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Correção do erro de permissão</TaskTitle>
                <TaskBreadcrumb>Agendas/ Planejamento de agenda</TaskBreadcrumb>
                <TaskDescription>
                  Correção do erro de permissão na listagem dos serviços como subitens da agenda.
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Filtragem por data dos agendamentos</TaskTitle>
                <TaskBreadcrumb>Agendas/ Agenda</TaskBreadcrumb>
                <TaskDescription>
                  Agora é possível filtrar os agendamentos de um agenda utilizando o calendário da plataforma
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="ATTENDANCES">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Finalização com comentário de um atendimento</TaskTitle>
                <TaskBreadcrumb>Atendimento/ Atendimento em campo</TaskBreadcrumb>
                <TaskDescription>
                  Agora ao clicar em &quot;finalizar atendimento&quot;, é possível escrever uma mensagem de observação.
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Listagem dos atendimentos com sublocalidade</TaskTitle>
                <TaskBreadcrumb>Atendimento / Atendimento em campo</TaskBreadcrumb>
                <TaskDescription>Correção da listagem de atendimentos filtrando pela sublocalidade</TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Agendamento listando o serviço correto</TaskTitle>
                <TaskBreadcrumb>Atendimento / Recepção</TaskBreadcrumb>
                <TaskDescription>
                  Correção do nome do serviço que não estava condizente com o serviço selecionado no ato de agendamento
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
